var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatarRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161 160",
    style: {
      enableBackground: "new 0 0 161 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,86H74.2c-6.7,0-13.1,2.7-17.8,7.4c-4.7,4.7-7.4,11.1-7.4,17.8c0,0.7,0.2,1.3,0.6,1.9 c0.4,0.5,0.9,0.9,1.6,1.1c9.6,2.5,19.4,3.6,29.3,3.3c9.9,0.3,19.7-0.8,29.3-3.3c0.6-0.2,1.2-0.6,1.6-1.1c0.4-0.5,0.6-1.2,0.6-1.9 c0-6.7-2.7-13.1-7.4-17.8C99.9,88.6,93.5,86,86.8,86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.5,79.7c9.8,0,17.3-10.9,17.3-20.3c0-4.6-1.8-9-5.1-12.3c-3.2-3.2-7.7-5.1-12.3-5.1c-4.6,0-9,1.8-12.3,5.1 c-3.2,3.2-5.1,7.7-5.1,12.3C63.2,68.7,70.7,79.7,80.5,79.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarRegistered);
export default __webpack_public_path__ + "static/media/default-avatar-registered.e17a2c178a0e6984309678789301a7bf.svg";
export { ForwardRef as ReactComponent };